ui-cms-add-comment {
  display: block;

  .comment-form {
    border-top: 1px solid $ui-grey;
    padding-top: $sd-spacing-8;
    margin-bottom: 3rem;

    .sd-headline {
      margin-bottom: $sd-spacing-8;
    }

    sd-link {
      display: block;
      margin: $sd-spacing-10 0;
    }

    sd-button {
      margin: $sd-spacing-8 0;
      display: block;
    }

    @include breakpoint($medium) {
      sd-button {
        width: fit-content;
        margin-left: auto;
        margin-top: -$sd-spacing-16;
      }
    }

    sd-checkbox {
      width: 100%;
    }

    .sd-paragraph {
      margin-top: $sd-spacing-16;
      color: $ui-grey-plus-2;
    }

    &__fields {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      gap: $sd-spacing-2;

      sd-input {
        width: 100%;
        margin-bottom: $sd-spacing-4;

        @include breakpoint($medium) {
          width: calc(50% - $sd-spacing-2);
          margin-bottom: $sd-spacing-4;
        }
      }

      sd-textarea {
        width: 100%;
        margin-bottom: $sd-spacing-4;
      }

      .error-message {
        color: $ui-red;
        margin-bottom: $sd-spacing-6;
      }
    }
  }
}
